import { useEffect, useRef, ReactNode } from 'react';
import { createPortal } from 'react-dom';

const modalRoot = document.querySelector('body') as HTMLElement;

type ModalProps = {
  children: ReactNode;
  portalClassName?: string;
};

export function RootPortal({ children, portalClassName = 'portal' }: ModalProps) {
  const elRef = useRef<HTMLDivElement | null>(null);

  if (!elRef.current) {
    const $el = document.createElement('div');
    $el.classList.add(portalClassName);
    elRef.current = $el;
  }

  useEffect(() => {
    const el = elRef.current!;
    modalRoot.appendChild(el);
    return () => {
      modalRoot.removeChild(el);
    };
  }, []);

  return createPortal(children, elRef.current);
}
